export { default as Search } from './Search'
export { default as Product } from './Product/'
export { default as Catalog } from './Catalog'
export { default as Bookmarks } from './Bookmarks'
export { default as Publication } from './Publication'
export { default as Agenda } from './Agenda'
export { default as Article } from './Article'
export { default as Challenge } from './Challenge'
export { default as Contact } from './Contact'
export { default as Counterfeits } from './Counterfeits'
export { default as Counterfeit } from './Counterfeit'
export { default as Faq } from './Faq'
export { default as Gift } from './Gift'
export { default as HubQuizz } from './HubQuizz'
export { default as Page } from './Page'
export { default as Quizz } from './Quizz/'
export { default as Ranking } from './Ranking'
export { default as Report } from './Report'
export { default as Sitemap } from './Sitemap'
export { default as SocialMedia } from './SocialMedia'
export { default as Stock } from './Stock'
export { default as Team } from './Team'
export { default as Thefts } from './Thefts'
export { default as User } from './User'
export { default as Theft } from './Theft'
export { default as Legals } from './Legals'
export { default as Privacy } from './Privacy'
export { default as Training } from './Training'
export { default as CatalogEvent } from './CatalogEvent'
export { default as Interviews } from './Interviews'
export { default as InDepth } from './InDepth'
export { default as CharityForm } from './CharityForm'
export { default as CharityCatalog } from './CharityCatalog'


// WEBPACK FOOTER //
// ./src/scenes/Pages/container/index.js